// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nXSt","right":"styles_right__1VM8g"};